// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;It goes well with those who are generous in lending&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and order their affairs with justice,<br> </p> </div></div>";
// Exports
module.exports = code;